import { render, staticRenderFns } from "./EmployeesList.vue?vue&type=template&id=20995a58&"
import script from "./EmployeesList.vue?vue&type=script&lang=js&"
export * from "./EmployeesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports